<app-nav-bar></app-nav-bar>
<app-side-bar></app-side-bar>
<app-settings-modal></app-settings-modal>

<div class="container">
  <div class="container-clients">
    <div class="header">
      <h1 class="title">{{'YOUR_CLIENTS' | translate}}</h1>
      <div class="buttons-container">
        <div class="dropdown" *ngIf="permissions?.exportClients">
          <a class="btn primary-btn dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
            {{'DOWNLOAD_FILE' | translate}}
          </a>

          <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <li><a class="dropdown-item" (click)="downloadClientsFile('excel')">📊 {{'EXPORT_TO' | translate}} Excel</a></li>
            <li><a class="dropdown-item" (click)="downloadClientsFile('json')">📜 {{'EXPORT_TO' | translate}} JSON</a></li>
            <li><a class="dropdown-item" (click)="downloadClientsFile('csv')">📄 {{'EXPORT_TO' | translate}} CSV</a></li>
            <li><a class="dropdown-item" (click)="downloadClientsFile('txt')">📑 {{'EXPORT_TO' | translate}} TXT</a></li>
          </ul>
        </div>
        <button type="button" class="primary-btn" [routerLink]="['/clients/create']">
          {{'NEW' | translate}}
        </button>
      </div>
    </div>
    <div class="actions d-flex justify-content-end">
        <div class="action-group" role="group" aria-label="Template actions">
          <div class="dropdown">
            <button
              type="button"
              class="btn-header btn-header-ghost dropdown-toggle"
              id="downloadTplDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              aria-label="Download template"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="#6abdcc" d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"/></svg>
              <span class="btn-header-text">{{ 'DOWNLOAD_TEMPLATE' | translate }}</span>
            </button>
            <ul class="dropdown-menu" aria-labelledby="downloadTplDropdown">
              <li>
                <a class="dropdown-item" (click)="downloadTemplate()">
                  {{ 'DOWNLOAD_TEMPLATE' | translate }}
                </a>
              </li>
            </ul>
          </div>
          <button type="button" class="btn-header btn-header-ghost" (click)="openClientUploadModal()" aria-label="Upload from template">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="#6abdcc" d="M11 16V7.85l-2.6 2.6L7 9l5-5l5 5l-1.4 1.45l-2.6-2.6V16zm-5 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"/></svg>
            <span class="btn-header-text">{{ 'UPLOAD_FROM_TEMPLATE' | translate }}</span>
          </button>
          <button type="button" class="btn-header btn-header-ghost" (click)="openEmailsUploadModal()" aria-label="Upload from template" *ngIf="[4, 12].includes(themingService.shopTheming[0].shopId)">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="#6abdcc" d="M11 16V7.85l-2.6 2.6L7 9l5-5l5 5l-1.4 1.45l-2.6-2.6V16zm-5 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"/></svg>
            <span class="btn-header-text">Subir Correos para Reenvio</span>
          </button>
        </div>
      </div>
    <div class="form-card">
      <div class="search-container">
        <input
          type="text"
          placeholder="{{'SEARCH' | translate}}"
          [(ngModel)]="searchString"
          (keyup)="serchClients()"
        />
        <div class="filters-container">
          <div class="">
            <select class="form-select" [(ngModel)]="order" (change)="filterSearch()">
              <option value="DESC">{{'MOST_RECENT' | translate}}</option>
              <option value="ASC">{{'OLDER' | translate}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="loading" *ngIf="loading">
        <div class="spinner-border" role="status"></div>
      </div>
      <table *ngIf="!loading" class="table table-bordered table-hover">
        <thead>
          <th scope="col" class="table-start">{{'NAME' | translate}}</th>
          <!-- <th scope="col">Etiquetas</th> -->
          <th scope="col">{{'EMAIL' | translate}}</th>
          <th scope="col">{{'ID_NUMBER' | translate}}</th>
          <th scope="col">{{'PHONE' | translate}}</th>
          <th scope="col">{{'EDIT' | translate}}</th>
          <th scope="col" class="table-end">{{'DELETE' | translate}}</th>
        </thead>
        <tbody>
          <tr *ngFor="let client of clients">
            <td class="client-name">
              <a
                *ngIf="client.username; else notVerifiedTemplate"
                [routerLink]="['/client', client.clientId]"
                routerLinkActive="active"
              >
                {{ [client.firstName || '', client.lastName || ''].join(' ').trim() }}
              </a>
              <ng-template #notVerifiedTemplate>
                <a (click)="notVerified()">
                  {{ [client.firstName || '', client.lastName || ''].join(' ').trim() }}
                </a>
              </ng-template>
            </td>

            <td>{{ client.email || '' }}</td>
            <td>{{ client.nationalId || '' }}</td>
            <td>{{ client.phone || '' }}</td>

            <td>
              <button
                type="button"
                class="primary-btn"
                [routerLink]="['/edit-clients', client.clientId]"
              >
                {{ 'EDIT' | translate }}
              </button>
            </td>
            <td>
              <button
                class="btn btn-primary remove-btn"
                (click)="modalDelete = true; clientIdToDelete = client.clientId; clientUsernameToDelete = client.username"
              >
                {{ 'DELETE' | translate }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="nav-container" *ngIf="!loading">
        <nav>
          <ul class="pagination">
            <li [ngClass]="{ 'page-item': true, disabled: currentPage == 1 }">
              <a
                class="page-link page-text-link"
                (click)="movePage(false)"
                tabindex="-1"
                unselectable="on"
                >{{'PREVIOUS' | translate}}</a
              >
            </li>
            <li
              *ngIf="pages[0] >= (maxNumberOfPages - 1) / 2"
              class="page-item disabled"
            >
              <a
                class="page-link page-number-link"
                unselectable="on"
                style="opacity: 1"
                >...</a
              >
            </li>
            <li
              *ngFor="let page of pages"
              [ngClass]="{ 'page-item': true, active: currentPage == page }"
            >
              <a
                class="page-link page-number-link"
                (click)="goToPage(page)"
                unselectable="on"
                >{{ page }}</a
              >
            </li>
            <li
              *ngIf="
                currentPage + (maxNumberOfPages - 1) / 2 < totalPages &&
                totalPages > maxNumberOfPages
              "
              class="page-item disabled"
            >
              <a
                class="page-link page-number-link"
                unselectable="on"
                style="opacity: 1"
                >...</a
              >
            </li>
            <li
              [ngClass]="{
                'page-item': true,
                disabled: currentPage == totalPages
              }"
            >
              <a
                class="page-link page-text-link"
                (click)="movePage(true)"
                tabindex="-1"
                unselectable="on"
              >
                {{'NEXT' | translate}}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

</div>

<div class="modal" tabindex="-1" role="dialog" id="customerSendEmail">
  <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="title">Reenviar códigos en lote</h3>
      </div>

      <div class="modal-body h-200px pb-0">
        
        <!-- Subir archivo -->
        <div>
          <form id="uploadEmailForm">
            <div class="mb-3">
              <input class="form-control" type="file" accept=".xlsx, .xls" (change)="onEmailsFileSelected($event)">
            </div>
          </form>
        </div>
        <!-- <div class="file-upload">
          <label class="file-label">
            <input type="file" accept=".xlsx, .xls" (change)="onEmailsFileSelected($event)" hidden />
            <span>Subir Archivo</span>
          </label>
          <div *ngIf="fileName" class="file-name">{{ fileName }}</div>
        </div> -->
        
        <!-- Errores -->
        <div *ngIf="invalidEmails.length > 0" class="error-section">
          <h4>Existen {{ invalidEmails.length }} correos inválidos: </h4>
          <ul>
            <li *ngFor="let email of invalidEmails">{{ email }}</li>
          </ul>
        </div>
        
        <!-- Resumen -->
        <div *ngIf="emails.length > 0" class="summary">
          <p>Correos válidos: <strong>{{ emails.length }}</strong></p>
        </div>
        
        <div *ngIf="resendEmailFinished">
          Reenvio de correos finalizado!
        </div>
      </div>
      <div class="modal-footer justify-content-end bg-white">

        <!-- Botón de acción -->
        <div class="actions">
          <button class="btn btn-outline-primary"
          *ngIf="!isProcessing && !hasErrors && emails.length > 0"
          (click)="onSendAll()"
          >
            Enviar Correos
          </button>
          
          <button *ngIf="isProcessing" disabled class="btn-processing">
            Procesando... {{ processedCount }}/{{ totalCount }}
            ({{ progressPercent }}%)
          </button>
          
          <button class="btn btn-danger" data-bs-dismiss="modal">Cancelar</button>
        </div>
      
        <!-- Barra de progreso -->
        <div *ngIf="isProcessing" class="progress-bar">
          <div class="progress-fill" [style.width.%]="progressPercent"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" role="dialog" id="customerUploadModal">
  <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
    <div class="modal-content">
      
      <!-- Header -->
      <div class="modal-header">
        <h3 class="title">Importar clientes por plantilla</h3>
      </div>

      <!-- Loading -->
      <div class="loading" *ngIf="modalLoading">
        <div class="spinner-border" role="status"></div>
      </div>

      <!-- Body -->
      <div class="modal-body h-200px pb-0" *ngIf="!modalLoading">
        
        <!-- Input archivo -->
        <div>
          <form id="uploadClientsForm">
            <div class="mb-3">
              <input class="form-control" type="file" accept=".xlsx" (change)="onFileSelected($event)">
            </div>
          </form>
        </div>

        <!-- Barra de carga -->
        <div *ngIf="isUploading">
          <div class="progress">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              aria-valuenow="0"
              aria-valuemin="0"
              aria-valuemax="100"
              [style]="uploadingStyle"
            >
              {{uploadPercentaje}}%
            </div>
          </div>
          <!-- <p>Cargando {{uploadingClients}} de {{totalClients}} clientes. Este proceso puede tomar varios minutos según la cantidad.</p> -->
        </div>

        <div *ngIf="uploadFinished">
          <div>Ha finalizado la carga de clientes.</div>
        </div>

        <!-- Error documento inválido -->
        <div *ngIf="!xlsxValid" class="alert alert-danger d-flex align-items-center" role="alert">
          <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img"><use xlink:href="#exclamation-triangle-fill"/></svg>
          <div>El documento no tiene el formato correcto.</div>
        </div>

        <!-- Tabla preview -->
        <div *ngIf="xlsxValid && !isUploading && previewData.length != 0" class="table-responsive">
          <table class="table-bordered table-hover w-100">
            <thead>
              <tr *ngIf="previewDataPagination.length != 0" class="table-header">
                <th>Nombre</th>
                <th>Apellido</th>
                <th>Identificación</th>
                <th>Id Empleado</th>
                <th>Beneficiarios</th>
                <th>Teléfono</th>
                <th>Email</th>
                <th>Género</th>
                <th>Fecha nacimiento</th>
                <th>Fecha de alta</th>
                <th>Login Method</th>
              </tr>
            </thead>

            <tbody>
              <tr
                *ngFor="let cell of previewDataPagination; let index = index"
                [class.bg-danger]="getError(index)"
                [title]="getError(index)"
              >
              <!-- <tr *ngFor="let cell of previewDataPagination; let index = index"> -->
                <td>{{ cell.firstName }}</td>
                <td>{{ cell.lastName }}</td>
                <td>{{ cell.nationalId }}</td>
                <td>{{ cell.employeeId }}</td>
                <td>{{ cell.beneficiaries.length }}</td>
                <td>{{ cell.phoneNumber }}</td>
                <td>{{ cell.email }}</td>
                <td>{{ cell.gender }}</td>
                <td>{{ cell.birthDate }}</td>
                <td>{{ cell.registrationDate }}</td>
                <td>{{ cell.loginMethod === 0 ? 'OTP_ONLY' : 'PASSWORD' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div *ngIf="previewTotalPages > 1 && !isUploading && previewData.length != 0" class="nav-container">
          <nav>
            <ul class="pagination">
              <li [class.page-item]="true" [class.disabled]="previewPageNumber == 1">
                <a class="page-link" (click)="movePreviewPage(false)">Anterior</a>
              </li>

              <li
                *ngFor="let page of previewPages"
                [class.page-item]="true"
                [class.active]="previewPageNumber == page"
              >
                <a class="page-link" (click)="goToPreviewPage(page)">{{ page }}</a>
              </li>

              <li
                [class.page-item]="true"
                [class.disabled]="previewPageNumber == previewTotalPages"
              >
                <a class="page-link" (click)="movePreviewPage(true)">Siguiente</a>
              </li>
            </ul>
          </nav>
        </div>

      </div>

      <!-- Footer -->
      <div *ngIf="xlsxValid && !isUploading && !previewError" class="modal-footer justify-content-end bg-white">
        
        <button class="btn btn-danger" data-bs-dismiss="modal">Cerrar</button>
        <button class="btn btn-outline-primary" (click)="confirmUploadClients()" [disabled]="previewData.length == 0">
          Procesar
        </button>
      </div>
      <div *ngIf="previewError" class="modal-footer justify-content-end bg-white">
        <button
          *ngIf="previewError"
          class="btn btn-danger mt-3"
          (click)="generateErrorList()">
          Ver errores
        </button>
      </div>

      <!-- <div *ngIf="previewError" class="modal-footer justify-content-end">
        <button class="btn btn-danger" (click)="showErrorLines()">Ver errores</button>
      </div> -->

    </div>
  </div>
</div>

<div class="modal fade" id="errorListModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">

      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title">Errores encontrados</h5>
      </div>

      <div class="modal-body" style="max-height:400px; overflow-y:auto;">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>Fila</th>
              <th>Error</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let e of rowErrors">
              <td>{{ e.index }}</td>
              <td>{{ e.error }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeErrorModal()">Cerrar</button>
      </div>

    </div>
  </div>
</div>

<div class="modal" id="errorClientsModal" tabindex="-1">
  <div class="modal-dialog product-modal-dialog" role="document">
    <div class="modal-content product-modal-content">
      <div class="modal-body product-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{ 'USER_NOT_VERIFIED' | translate }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger cancel-btn" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<app-confirmation-modal
*ngIf="modalDelete"
[title]="'¿Seguro que quiere eliminar este cliente?'"
[message]="'Al eliminar este usuario se eliminarán todos los datos que estén relacionados a él permanentemente'"
[confirmText]="'Eliminar'"
[cancelText]="'Cancelar'"
(response)="deleteClient($event)">
</app-confirmation-modal>

<div class="modal delete-client-confirm-modal"  id="deleteClientModal" tabindex="-1">
  <div class="modal-dialog client-modal-dialog" role="document">
    <div class="modal-content client-modal-content">
      <div class="modal-body client-modal-body">
        <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
        <p class="text-center">{{ 'CLIENT_DELETED_SUCCESS' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
